/**
 * The JetBrains Modul face is set in lowercase only — that is how the brand
 * writes "air", and the frames never show it capitalised. Two layers enforce
 * it: the CSS `text-transform: lowercase` on every Modul slot decides what is
 * drawn and exported, whatever the stored text; this normaliser decides what
 * is stored, so typed or pasted capitals never reach the scene either.
 *
 * Locale-aware, so "İ" and friends fold the way the user's language expects.
 */
export function toModulCase(text: string): string {
  return text.toLocaleLowerCase();
}
